import ButtonCloseMenu from "components/button-close";
import { useState } from "react";
import Button from "components/button";
import { ErrorInput, ReturnText, SelectGender } from "theme/theme";
import { dlTrackEvent } from "components/dataLayer/dataLayer";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import textServices from "services/text-services";
import { yupResolver } from "@hookform/resolvers/yup";
import formServices from "services/form-builder-services";
import { useSession } from "contexts/session-context";
import { useGroups } from ".";

export default function HowDoYouWantToParticipate() {
  const [{ callbackParticipate, groups }, { setOpenSelectParticipate, setParticipateGroupId, setCallbackParticipate, setOpenCreate }] = useGroups()
  const { register, formState: { errors }, handleSubmit } = useForm<{ clusterId: string }>({ resolver: yupResolver(formServices.formGenerateSchema(["clusterId"])) })
  const [step, setStep] = useState(0)
  const [{ user }] = useSession()

  const handleMenu = () => {
    setOpenSelectParticipate(false)
    setParticipateGroupId(null)

    if (callbackParticipate) {
      setCallbackParticipate(() => null)
      callbackParticipate()
    }
  }

  const handleCreate = () => {
    setOpenCreate(true)
  }

  const onSubmit = handleSubmit((data) => {
    setOpenSelectParticipate(false)

    const group = groups.find((item) => item.cluster.id === Number(data?.clusterId))
    const clusterProfileId = group.group?.find((item) => item.profileId === user.id)?.id

    setParticipateGroupId(clusterProfileId)
    if (callbackParticipate) {
      setCallbackParticipate(() => null)
      callbackParticipate()
    }
  })

  return (
    <div className="fixed flex flex-col items-center z-40 top-0 left-0 w-screen h-screen bg-white groups__how-do-you-want-participate">
      <ButtonCloseMenu paramFn={handleMenu} />
      <div className="flex-1 w-full flex flex-col sm:max-w-sm pt-24 pb-8 px-5">
        <div className="flex-1 flex flex-col gap-6">
          <h3 className="title big text-center">¿Cómo quieres participar?</h3>
          <div className="flex-1">
            {
              step === 0 ? (
                <div className="w-full space-y-2">
                  <Button className="button-group" onClick={handleMenu}>DE FORMA INDIVIDUAL</Button>
                  <Button className="button-group" onClick={() => setStep(1)}>COMO GRUPO</Button>
                </div>
              ) : (
                <form className="gap-2 flex flex-col input-container">
                  {
                    groups?.length === 0 ? (
                      <p className="text-center text big">{textServices.findByText('groups/start/not-found', { es: <>Aún no eres parte de ningún grupo.<br />¿Qué esperas? vamos a crear uno.</>, en: <>You are not yet part of any group.<br />What are you waiting for?Let&apos;s create one.</> })}</p>
                    ) : (
                      <>
                        <SelectGender
                          name="clusterId"
                          {...register('clusterId', {
                            onBlur: (e) => {
                              dlTrackEvent('form_interaction', {
                                form_field: 'selecciona tu grupo',
                                form_action: e.target.value ? 'complete' : 'empty',
                                form_name: 'select group',
                                section: 'select group'
                              })
                            }
                          })}
                          className="text-xs font-bold p-4 w-full min-h-2 mx-auto saira uppercase input-select"
                        >
                          <option value="">Seleccionar grupo</option>
                          {groups?.map((item) => (
                            <option key={item?.cluster?.id} value={`${item?.cluster?.id}`}>
                              {item?.cluster?.name}
                            </option>
                          ))}
                        </SelectGender>
                        <ErrorInput className='input-error'>
                          <ErrorMessage errors={errors} name="clusterId" />
                        </ErrorInput>
                      </>
                    )
                  }
                </form>
              )
            }
          </div>
          <div className="flex flex-col gap-2">
            {step === 1 && <Button onClick={groups?.length === 0 ? handleCreate : onSubmit}>{groups?.length === 0 ? 'Crear grupo' : 'Confirmar'}</Button>}
            {step === 1 &&
              <button type="button" className="cursor-pointer" onClick={() => setStep(0)}>
                <ReturnText
                  className={`din text-center mt-3 hover:text-red-100 uppercase underline button-back`}
                  style={{ fontSize: 10 }}
                >
                  {textServices.findByText('backButton', { es: 'VOLVER', en: 'BACK TO' })}
                </ReturnText>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  )
}